export class FadeIn {
    constructor() {

        this.fadeinOnScorll()
    }

    fadeinOnScorll() {
        let $items = $('.fade-in');
        $items.each(function() {
            let $item = $(this);
            let itemOffset = $item.offset().top;

            if ($(window).scrollTop() + $(window).height() > itemOffset + 20) {
                $item.addClass('animate');
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/Frontend/Themes/Custom/src/Js/Theme/FadeIn.js